import { makeStyles } from 'tss-react/mui';

const resolveSubtabColor = (theme, isKiteUser, isActive) => {
  if (!isActive) {
    return theme.palette.grey2;
  } else {
    return isKiteUser ? theme.palette.primary2 : theme.palette.primary1;
  }
};

export const useStyles = makeStyles()(
  (theme, { isKiteUser, isActive } = {}) => ({
    tabs: {
      overflowX: 'auto',
      msOverflowStyle: 'none' /* IE and Edge */,
      scrollbarWidth: 'none' /* Firefox */,
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    tab: {
      color: resolveSubtabColor(theme, isKiteUser, isActive),
      backgroundColor: isActive ? theme.palette.lightGrey : 'transparent',
      ...theme.typography.textSm,
      [theme.breakpoints.down('lg')]: {
        '&:focus': {
          backgroundColor: isActive && theme.palette.lightGrey,
        },
        '&:hover': {
          backgroundColor: !isActive && 'inherit',
        },
      },
    },
  }),
);
